import React, { useContext } from 'react'
import { Segment, Button, Divider, Header, Container } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../../App/stores/RootStore'

const RequestReviewSubmitConfirmation = () => {
    const rootStore = useContext(RootStoreContext);
    const { closeModal } = rootStore.modalStore;
    const { RequestReview, requestResult, CompleteReview, ValidationResult, submitting } = rootStore.requestReviewStore

    return (
        <Segment clearing>
            <Header>Confirm Review Result</Header>
            <Divider />
            <Container>
                Are you sure you are ready to complete the review?  Your result for the request is {requestResult}.
            </Container>

            <Divider />

            <Button
                content="Submit"
                floated='right'
                labelPosition='right'
                icon='arrow alternate circle right'
                onClick={() => CompleteReview("")}
                disabled={ValidationResult?.shouldCalate || submitting}
                loading={submitting}
                positive
            />
            <Button
                content="Not yet"
                floated='left'
                labelPosition='right'
                icon='arrow alternate circle right'
                onClick={() => closeModal()}
                disabled={submitting}
                negative
            />

            <Divider hidden clearing />
            
            <Button
                content="DeEscalate"
                floated='left'
                labelPosition='left'
                icon='angle double down'
                onClick={() => CompleteReview("DeEscalated for Additional Review")}
                disabled={(RequestReview?.status === "Under Recommendation Review") || submitting}
                loading={submitting}
                color='pink'
            />
            <Button
                content="Escalate"
                floated='right'
                labelPosition='right'
                icon='angle double up'
                onClick={() => CompleteReview("Escalate for Additional Review")}
                disabled={(RequestReview?.status === "Under Additional Review") || (RequestReview?.status == "Under Recommendation Review") || submitting}
                loading={submitting}
                color='purple'
            />
        </Segment>

    );
}
export default observer(RequestReviewSubmitConfirmation);